export default "__VITE_ASSET__oa0bBZo047rF7AQKkCO8pQ__"